import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import {
  fetchMe,
  logoutComplete,
  refreshTokenFunc,
  resetUnauthorized,
} from 'redux/users/actions';

import { getCookie, setCookies, removeCookie } from 'utils/cookies';


class MainAuthContainer extends Component {
  static propTypes = {
    fetchMe: PropTypes.func.isRequired,
    logoutComplete: PropTypes.func.isRequired,
    refreshTokenFunc: PropTypes.func.isRequired,
    resetUnauthorized: PropTypes.func.isRequired,
    children: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.arrayOf(PropTypes.element),
      PropTypes.string,
    ]).isRequired,
    me: PropTypes.object,
    accessToken: PropTypes.string,
    refreshToken: PropTypes.string,
    unauthorized: PropTypes.bool,
  }

  static defaultProps = {
    me: null,
    accessToken: null,
    refreshTokenFunc: null,
    refreshToken: null,
    unauthorized: false,
  }

  componentDidMount() {
    const cookieAccessToken = getCookie('accessToken');
    const cookieRefreshToken = getCookie('refreshToken');

    if (cookieAccessToken) {
      this.props.fetchMe();
    }

    if (!cookieAccessToken && cookieRefreshToken) {
      this.props.refreshTokenFunc(cookieRefreshToken);
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.accessToken && this.props.accessToken) {
      setCookies(this.props.accessToken, this.props.refreshToken);
      this.props.fetchMe();
    }

    if (!prevProps.loggingOut && this.props.loggingOut) {
      removeCookie();
      this.props.logoutComplete();
      window.location.href = '/';
      window.location.reload();
    }
  }

  render() {
    const { me, unauthorized, resetUnauthorized, children } = this.props;
    if (me && unauthorized) { resetUnauthorized(); }

    return (
      <Fragment>{children}</Fragment>
    );
  }
}

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    accessToken: state.usersReducer.accessToken,
    refreshToken: state.usersReducer.refreshToken,
    loggingOut: state.usersReducer.loggingOut,
    unauthorized: state.usersReducer.unauthorized,
  }
);

export default connect(
  mapStateToProps,
  {
    fetchMe,
    logoutComplete,
    refreshTokenFunc,
    resetUnauthorized,
  },
)(MainAuthContainer);
